import { api } from "../api/requests";
import Disbursement from "../models/Disbursement";
import Loan from "../models/Loan";
import { completeDisbursementDTO } from "../resources/interfaces";

// Get All Disbursements
export async function getAllDisbursements(pageNumber?: number, pageSize?: number, offset?: number, paged?: boolean, search?: string, sort?: { sorted: boolean, unsorted: boolean }, unpaged?: boolean): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/disbursements?pageNumber=${pageNumber}&pageSize=${pageSize}${offset ? `&offset=${offset}` : ''}${paged ? `&paged=${paged}` : ''}${search ? `&search=${search}` : ''}${sort ? `&sort.sorted=${sort?.sorted}&sort.unsorted=${sort?.unsorted}` : ''}${unpaged ? `&unpaged=${unpaged}` : ''}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get Disbursement By Id
export async function getDisbursementById(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/disbursements/${id}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Create a new disbursement
export async function createDisbursement(disbursement: Disbursement): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/disbursements`, disbursement)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Cancel a disbursement
export async function cancelDisbursement(id: number): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/disbursements/${id}/cancel`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Complete a disbursement
export async function completeDisbursement(id: number, payload: completeDisbursementDTO): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/disbursements/${id}/complete`, payload)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Add loans to a disbursement
export async function addLoansToDisbursement(id: number, loans: Loan[]): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/disbursements/${id}/loans`, loans)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Remove a loan from a disbursement
export async function removeLoanFromDisbursement(id: number, loanId: number): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.delete(`admin/disbursements/${id}/loans/${loanId}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Process a disbursement
export async function processDisbursement(id: number): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/disbursements/${id}/process`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get disbursements by financier
export async function getDisbursementsByFinancier(financierId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/disbursements/financier/${financierId}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get disbursements by recipient
export async function getDisbursementsByRecipient(recipientId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/disbursements/recipient/${recipientId}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Search disbursements
export async function searchDisbursements(search: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/disbursements/search?search=${search}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get disbursements by status
export async function getDisbursementsByStatus(status: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/disbursements/status/${status}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Upload disbursement evidence
export async function uploadDisbursementEvidence(id: number, file: any): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/disbursements/${id}/upload-evidence`, { file: file })
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}